import React from 'react';
import { Section, SectionTitle } from '../../../components/TwoColumnLayout';
import styled from 'styled-components';
import { StyledInput } from '../../../components/StyledInput';
import { CustomerValues } from '../CustomerValues';

interface Props {
	accountType: string;
	customerValues: CustomerValues;
	customerContactData: any;
	handleCustomerDataChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Wrapper = styled.div`
  width: 18em;
  margin: auto;
`;

const Container = styled.div`
  min-height:120px;

  padding-top: 1rem;
    input {
    width: 250px;
  }

  input[type="text"] {
    min-width: 450px;
  }

  .info{
    width: 200px;
    font-size: 1rem;
    padding-left: 1rem;
    // border: 1px solid red;
  }

  .grayInfo{
    font-size: 1rem;
    color: darkgray;
  }
`;

const InputContainer = styled.div`
  width: 100%;
  height: 2.5em;
  margin-bottom: 2em;
`;

export const UserInfo: React.FC<Props> = (props: Props) => {
	return (
		<div>
			<Wrapper>
				{props.accountType === 'consumer' && (
					<div>
						<InputContainer>
							<StyledInput
								title={'Etunimi'}
								name={'firstName'}
								backgroundColor={'white'}
								value={props.customerContactData.firstName}
								readOnly
							/>
						</InputContainer>
						<InputContainer>
							<StyledInput
								title={'Sukunimi'}
								name={'lastName'}
								backgroundColor={'white'}
								value={props.customerContactData.lastName}
								readOnly
							/>
						</InputContainer>
						<InputContainer>
							<StyledInput
								title={'Puhelinnumero josta Moi tavoittaa sinut'}
								name={'phoneNumber'}
								backgroundColor={'white'}
								value={props.customerValues.phoneNumber.value !== null ? props.customerValues.phoneNumber.value : props.customerContactData.phoneNumber}
								onChange={props.handleCustomerDataChange}
							/>
						</InputContainer>
					</div>
				)}
			</Wrapper>
			{props.accountType !== 'consumer' && (
				<div>
					<SectionTitle>Käyttäjän tiedot</SectionTitle>
					<Section>
						<Container>
							<div className="info">
								<input
									value={props.customerContactData.firstName ? props.customerContactData.firstName : 'Tietoa ei saatavilla'}
									type="text"
									readOnly
								/>
								<input
									value={props.customerContactData.emailAddress ? props.customerContactData.emailAddress : 'Tietoa ei saatavilla'}
									type="text"
									readOnly
								/>
								<input
									value={props.customerContactData.phoneNumber ? props.customerContactData.phoneNumber : 'Tietoa ei saatavilla'}
									type="text"
									readOnly
								/>
							</div>
						</Container>
					</Section>
				</div>
			)}
		</div>
	);
}